import deps from "../depsloader";

export default () => {
  deps.load("swiper").then((swiper) => {
    const Swiper = swiper.Swiper;

    const elms = document.querySelectorAll(".swiper-container");
    elms.forEach((elm) => {
      let config = {};

      if (elm.dataset.config) {
        config = JSON.parse(elm.dataset.config);
        elm.removeAttribute("data-config");
      }

      new Swiper(elm, config);
    });
  });
}
